import type {SubgoalApiModel} from '../../../api/goal';
import type {Theme} from '../../../styles/theme';
import type {ColorsV3} from '../../../styles/theme/colors/v3';
import type {DeepKeyIn} from '../../utility-types';

export const DEFAULT_SUBGOAL_COLOR: SubgoalColor = 'goal1';

export type SubgoalColor = DeepKeyIn<ColorsV3['goals']> | null;

export const SUBGOAL_COLORS: SubgoalColor[] = [
  'goal1',
  'goal2',
  'goal3',
  'goal4',
  'goal5',
  'goal6',
  'goal7',
  'goal8',
  'goal9',
  'goal10',
  'goal11',
  'goal12',
];

export const getSubgoalColor = (
  color: SubgoalApiModel['color'],
  theme: Theme,
): string => {
  const defaultColor = theme.color.v3.goals[DEFAULT_SUBGOAL_COLOR];

  return color ? theme.color.v3.goals[color] || defaultColor : defaultColor;
};
